<div class="main-modal-container">
  <div class="close-modal-container">
    <img
      (click)="closeModal()"
      src="/assets/icons/ close-modal-icon.png"
      alt=""
    />
  </div>
  <div class="modal-content">
    <ng-container *ngIf="modalType == 'deleteCard'">
      <h1 class="label-title">Delete Card</h1>
      <h3>Are you sure you want to delete this card?</h3>
      <div class="container">
        <img [src]="cardImage(card.card.brand)" alt="" />
        <div>
          <div class="digits">
            <span>****</span>
            <span>****</span>
            <span>****</span>
          </div>
          <label for=""> {{ card.card.last4 }}</label>
        </div>
      </div>
      <button
        class="modal-button"
        (click)="deleteCard()"
        gbui-button
        type="submit"
      >
        Delete
      </button>
    </ng-container>

    <ng-container *ngIf="modalType == 'deleteCardSuccess'">
      <div class="deleteCardSuccess">
        <img
          class="modal-success-icon"
          src="/assets/icons/success-modal-icon.png"
          alt=""
        />
        <h1 class="label-title">Deleted Successfully</h1>
        <h3>Your card has been deleted successfully.</h3>

        <button
          class="modal-button"
          gbui-button
          type="submit"
          (click)="closeModal()"
        >
          Go Back
        </button>
      </div>
    </ng-container>

    <ng-container *ngIf="modalType == 'cancelMembership'">
      <h1 class="label-title">
        Are you sure you want to <br />
        end your membership?
      </h1>

      <h3 class="remove-membership-description">
        If you end your membership you will no longer have access to Check Plus
        features and all data will be deleted permanently in 30 days.
      </h3>
      <div>
        <div class="cards">
          <div class="">
            <h1>{{ subscription.name }}</h1>
            <div class="date-container">
              <label class="expire-date">
                Expires in {{ formatDate(currentPeriodEnd) }}
              </label>
            </div>
            <!-- <label class="description">{{ item?.description }}</label> -->
            <label class="price">${{ numberFormat(subscription.price) }}</label>
            <label class="interval">{{ subscription.recurrentInterval }}</label>
          </div>
        </div>
      </div>
      <gbui-button
        class="modal-button end-membership"
        type="submit"
        [ngClass]="{ 'disable-content': endMembershipLoading$ | async }"
        (click)="endMembership()"
        [busy]="(endMembershipLoading$ | async) ?? false"
      >
        End Membership
      </gbui-button>
    </ng-container>
  </div>
</div>
